import EventbriteActivation from './EventbriteActivation';

export default EventbriteActivation;
